import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=d6d22a42&scoped=true"
import script from "./productDetail.vue?vue&type=script&lang=js"
export * from "./productDetail.vue?vue&type=script&lang=js"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=d6d22a42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d22a42",
  null
  
)

export default component.exports